<template>
  <v-card class="daily-card">
    <v-card-title class="title">{{ title }}</v-card-title>
    <v-data-table :headers="headers" :items="items" class="custom-table" hide-actions>
      <template v-slot:items="props">
        <td>{{ props.item.name }} ({{ props.item.unit }})</td>
        <td class="text-xs-center">
          <span :class="props.item.actual.value == 'N/A' ? 'error--text' : 'number--text'">{{ props.item.actual.value }}</span>
        </td>
        <td class="text-xs-center">
          <span :class="props.item.expected.value == 'N/A' ? 'error--text' : 'number--text'">{{ props.item.expected.value }}</span>
        </td>

      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    headers: {
      type: Array,
      default: function () {
        return []
      }
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
}
</script>

<style scoped>
.daily-card {
  background-color: var(--v-primary-base) !important;
  color: var(--primarytext);
  border-radius: 10px;
  box-shadow: 0 5px 5px 0 #334079;
}

.title {
  color: var(--primarytext);
  font-size: 14px;
  text-align: center;
  display:flex;
  justify-content: center;
}

.custom-table {
  border-top: 1px solid #344079;
}

.custom-table td,
.custom-table th {
  border: 1px solid #344079;
  text-align: left;
}

</style>
